import dynamic from 'next/dynamic';
import { useState } from 'react';

import LazyLoad from 'react-lazyload';
import { relatedPostsPDP } from '../../../Constants/RelatedPostPDP';
import ImageGalleryWrapper from '../ImageGallaryCarousel/ImageGalleryWrapper';
import { TwoGrid } from '../PdpCarousel/styled';
import WidgetsMergeCover from '../WidgetsMergeCover';
import {
  diaperComboPdpIds,
  diaperPdpIds,
} from '../FertilityTrustSection/constant';
import { wrapperSkus } from '../../CartOverlayContainer/Cart/Constants';
import { SnackBar } from '../PdpHeader/styled';
import Cookies from 'js-cookie';
import { useEffect } from 'react';

const RelatedPosts = dynamic(() => import('../RelatedPosts/Aplusplus'), {
  ssr: false,
});
const SimilarProducts = dynamic(
  () => import('../SimilarProducts/similarProduct'),
  { ssr: false },
);
const TuesdaysalePopup = dynamic(
  () => import('../../TuesdaySale/TuesdaysalePopup'),
  { ssr: false },
);

function Widget(props) {
  const {
    productData,
    setAddedToCart,
    priceData,
    offerList,
    showLighteningDeal,
    setChangeCartCount,
    showTuesdayPopup,
    setShowTuesdayPopup,
    user_review_images,
    userType,
    experimentUserType,
    videoRef,
    isFullScreenVideoEnabled,
    setIsFullScreenVideoEnabled,
    showFullScreenVideo,
    setShowFullScreenVideo,
    currentVideoIndex,
    setCurrentVideoIndex,
    generalItemData,
    sddNddData,
  } = props;

  const [showSizePopup, setShowSizePopup] = useState(false);
  const [showToast, setShowToast] = useState('');
  const features = [
    { feature: 'Shatavari', bg: '#e7ffa6a3' },
    { feature: 'CoQ10', bg: '#e7f9fc' },
    { feature: 'L-Methylfolate', bg: '#ef4e5e66' },
    { feature: 'Vitamin B12', bg: '#b3e7f2c2' },
    { feature: 'Vitamin D2 Veg', bg: '#02a50436' },
    { feature: 'Zinc', bg: '#8242773b' },
  ];
  const ProductId = productData?.id;
  const isFertilityProduct = [3408, 3662, 3663].includes(productData?.id);
  const isWrapperPdp = wrapperSkus.includes(productData?.id);
  const showNewDiaperVariantUx = diaperPdpIds.includes(productData?.variant_id);
  const showNewDiaperComboPdp = diaperComboPdpIds.includes(productData?.id);

  useEffect(() => {
    if (Cookies.get('showToast')) {
      Cookies.remove('showToast');
      setShowToast('Thank you for your feedback!');
      setTimeout(() => {
        setShowToast(null);
      }, 2500);
    }
  }, []);

  return (
    <>
      <TwoGrid>
        <ImageGalleryWrapper
          productData={productData}
          user_review_images={user_review_images}
          userType={userType}
          setAddedToCart={setAddedToCart}
          showSizePopup={setShowSizePopup}
          isFertilityProduct={isFertilityProduct}
          features={features}
          showNewDiaperVariantUx={showNewDiaperVariantUx}
          isWrapperPdp={isWrapperPdp}
          videoRef={videoRef}
        />
        <WidgetsMergeCover
          productData={productData}
          setAddedToCart={setAddedToCart}
          priceData={priceData}
          offerList={offerList}
          features={features}
          showLighteningDeal={showLighteningDeal}
          showSizePopup={showSizePopup}
          setShowSizePopup={setShowSizePopup}
          userType={userType}
          experimentUserType={experimentUserType}
          showNewDiaperVariantUx={showNewDiaperVariantUx}
          showNewDiaperComboPdp={showNewDiaperComboPdp}
          isWrapperPdp={isWrapperPdp}
          isFullScreenVideoEnabled={isFullScreenVideoEnabled}
          setIsFullScreenVideoEnabled={setIsFullScreenVideoEnabled}
          showFullScreenVideo={showFullScreenVideo}
          setShowFullScreenVideo={setShowFullScreenVideo}
          currentVideoIndex={currentVideoIndex}
          setCurrentVideoIndex={setCurrentVideoIndex}
          generalItemData={generalItemData}
          sddNddData={sddNddData}
        />
      </TwoGrid>
      <LazyLoad height={100} once offset={300}>
        <SimilarProducts
          setChangeCartCount={setChangeCartCount}
          productCategory={productData?.product_category}
          productId={ProductId}
          brandName={productData?.brandName}
        />
        {relatedPostsPDP[ProductId] && (
          <RelatedPosts
            data={relatedPostsPDP[ProductId]}
            productData={productData}
          />
        )}
      </LazyLoad>
      {showTuesdayPopup && (
        <TuesdaysalePopup
          showpopup={showTuesdayPopup}
          setClosePopup={setShowTuesdayPopup}
        />
      )}
      {showToast && (
        <SnackBar className={showToast ? 'show' : ''}>{showToast}</SnackBar>
      )}
    </>
  );
}

export default Widget;
